import _ from 'lodash';

export function progressBackgroundDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: progressBackgroundDirectiveCtrl,
	};
}

export class progressBackgroundDirectiveCtrl {
	constructor($scope, $element, $attrs, $interval) {
		'ngInject';
		// save injections
		this.element = $element[0];
		this.$interval = $interval;
		// watch for attr changes
		if (this.element.hasAttribute('sh-progress-background')) {
			$scope.$watch($attrs.shProgressBackground, this.setPercent.bind(this));
		}
		if (this.element.hasAttribute('sh-progress-background-colors')) {
			$scope.$watch($attrs.shProgressBackgroundColors, this.setBarColors.bind(this));
		}
		if (this.element.hasAttribute('sh-progress-background-countdown')) {
			$scope.$watch($attrs.shProgressBackgroundCountdown, this.startCountdown.bind(this));
		}
	}

	$onDestroy() {
		this.$interval.cancel(this.countdownInterval);
	}

	setPercent(percent) {
		this.percent = percent;
		this.showPercent();
	}

	setBarColors(colors) {
		this.colors = colors;
		this.showPercent();
	}

	getBarColors() {
		if (_.isArray(this.colors) && this.colors.length >= 2) {
			return this.colors;
		}
		return ['rgba(255,255,255,0.33)', 'rgba(255,255,255,0)'];
	}

	startCountdown(ms) {
		this.$interval.cancel(this.countdownInterval);
		ms = parseFloat(ms) || 0;
		if (ms > 500) {
			let elapsed = 0;
			this.countdownInterval = this.$interval(() => {
				let percent;
				elapsed += 500;
				if (elapsed < ms) {
					// linearly creep between 20% and 85%
					percent = 20 + (elapsed / ms) * 80;
				} else if (elapsed - 14000 < ms) {
					// after that, slowly creep from 85 to 99
					percent = 85 + (elapsed - ms) / 14000;
				} else {
					// after that, percent should be 99
					percent = 99;
					this.$interval.cancel(this.countdownInterval);
				}
				this.setPercent(percent);
			}, 500);
			this.setPercent(15);
		} else {
			this.setPercent(null);
		}
	}

	showPercent() {
		this.element.style.background = this.getBackground();
	}

	getBackground() {
		const colors = this.getBarColors();
		const rawPercent = this.percent;
		const intPercent = Math.floor(parseFloat(this.percent));
		if (rawPercent === undefined || rawPercent === null || rawPercent === false || intPercent >= 100) {
			return '';
		} else if (intPercent === 0) {
			return colors[1];
		} else {
			// example: linear-gradient(to right, #000 0%, #000 49.9%, #fff 50%, #fff 100%);
			return `
				linear-gradient(
					to right, 
					${colors[0]} 0%, 
					${colors[0]} ${(intPercent - 0.01).toFixed(2)}%, 
					${colors[1]} ${intPercent}%, 
					${colors[1]} 100%
				)
			`;
		}
	}
}
